module.exports = __webpack_public_path__ + "media/images/landing_page/13-8d9553dae9ebbc3047c52a7ad4638bd6.png";